var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnStarRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icn-star-rating_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#838791",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icn-star-rating_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.573l-3.2 1.914a.622.622 0 01-.332.068.613.613 0 01-.277-.102.489.489 0 01-.186-.255.511.511 0 01-.005-.336l.84-3.556L4.02 8.91a.495.495 0 01-.174-.28.627.627 0 01.013-.316.498.498 0 01.173-.251.545.545 0 01.305-.113l3.693-.33L9.497 4.23a.575.575 0 01.211-.256.538.538 0 01.292-.082c.107 0 .204.027.292.082.087.055.158.14.211.256l1.467 3.413 3.693.31c.119.008.22.049.305.122.084.073.142.16.173.262a.523.523 0 01.002.305.557.557 0 01-.183.27l-2.8 2.395.84 3.556a.512.512 0 01-.005.335.489.489 0 01-.186.256.614.614 0 01-.277.102.622.622 0 01-.332-.068L10 13.573z",
    fill: "currentColor"
  }))));
}
export default SvgIcnStarRating;